module.exports = __webpack_public_path__ + "img/logo-adn-100.9ab7f3e4.jpg";